
















import Vue from "vue";
import { ListHeader } from "../MyListCard.vue";
import { axios } from "@/plugins";

const ListHeaders: { NFS: ListHeader[]; CEPH_RBD: ListHeader[] } = {
  NFS: [
    { title: "名称", key: "storageClassName" },
    { title: "NFS地址", key: "server" },
    { title: "NFS路径", key: "path" },
    { title: "NFS描述", key: "description" }
  ],
  CEPH_RBD: [
    { title: "名称", key: "metadata.name" },
    {
      title: "描述",
      //  appmgr__object__description 中 __ 会 转译为 .
      key: "metadata.annotations.appmgr__object__description"
    },
    { title: "adminId", key: "parameters.adminId" },
    { title: "adminSecretName", key: "parameters.adminSecretName" },
    { title: "adminSecretNamespace", key: "parameters.adminSecretNamespace" },
    { title: "fsType", key: "parameters.fsType" },
    { title: "imageFeatures", key: "parameters.imageFeatures" },
    { title: "imageFormat", key: "parameters.imageFormat" },
    { title: "monitors", key: "parameters.monitors" },
    { title: "pool", key: "parameters.pool" },
    { title: "userId", key: "parameters.userId" },
    { title: "userSecretName", key: "parameters.userSecretName" },
    { title: "userSecretNamespace", key: "parameters.userSecretNamespace" }
  ]
};
export default Vue.extend({
  name: "StorageInfo",
  props: {
    tenantId: {
      type: String
    }
  },
  data() {
    return {
      dialog: false,
      ListHeaders,
      type: "NFS",
      listData: {}
    };
  },
  methods: {
    show(data: any) {
      this.dialog = true;
      this.type = data.metadata.annotations["appmgr.sc.type"];
      this.getData(data.metadata.name);
    },
    close() {
      this.dialog = false;
    },
    getData(storageClassName: string) {
      axios
        .get(`/storageclass/details/${this.tenantId}/${storageClassName}`)
        .then(res => {
          this.listData = res.data.data;
        });
    }
  }
});
